/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/**
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 * Gegenereerd met Claude Code (AI), 08-09-2026
 *
 * Een melding waarop luisteraars zich abonneren: de vorm die de services van de api-stap gebruiken
 * om elkaar iets te laten weten zonder elkaar te injecteren (`DlModel.bijGraafGetekend`,
 * `OpslagService.bijHerladen`, `NormService.bijNormdata`). Zo blijft de afhankelijkheidsrichting
 * één kant op lopen: wie iets doet meldt het, wie erop moet reageren luistert.
 *
 * De luisteraars lopen **synchroon**, in volgorde van registratie, in dezelfde tick als de aanleiding.
 * (Tot golf 4f zette de ng1-façade er zijn `$rootScope.$broadcast` achter, en die luisteraars rekenden
 * daarop.)
 */
export class Melding<T = void> {

    private readonly luisteraars: Array<(arg: T) => void | Promise<void>> = [];

    /**
     * Voegt een luisteraar toe en geeft de functie terug die hem weer afmeldt. Een service leeft de hele
     * sessie en hoeft zich niet af te melden; een component dat opnieuw kan worden aangemaakt wel, anders
     * blijft zijn oude luisteraar een vernietigde view bijwerken.
     */
    public abonneer(luisteraar: (arg: T) => void | Promise<void>): () => void {
        this.luisteraars.push(luisteraar);
        return () => {
            const plek = this.luisteraars.indexOf(luisteraar);
            if (plek >= 0) {
                this.luisteraars.splice(plek, 1);
            }
        };
    }

    /**
     * Roept alle luisteraars aan en geeft terug wat ze opleverden. Een melding waarvan de afloop
     * telt — de eerste opslag, waarna de samenwerkregistratie moet staan voordat het plaatje
     * vertrekt — wacht op die uitkomsten; de rest negeert ze.
     */
    public meld(arg: T): Array<void | Promise<void>> {
        //over een kopie: een luisteraar die zich tijdens het melden afmeldt, mag de volgende niet overslaan
        return [...this.luisteraars].map(luisteraar => luisteraar(arg));
    }
}
